import React from "react";
import { EdgeProps, getBezierPath } from "reactflow";

/**
 * Custom edge component that displays order numbers for sequence nodes
 * Shows a small circular badge with the execution order number
 */
const SequenceEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const order = data?.order;
  const showOrder = order !== undefined && order !== null;

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {showOrder && (
        <g transform={`translate(${labelX}, ${labelY})`}>
          {/* Circle background */}
          <circle
            cx={0}
            cy={0}
            r={12}
            fill="white"
            stroke="#3B82F6"
            strokeWidth={2}
            style={{
              filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.1))",
            }}
          />
          {/* Order number */}
          <text
            x={0}
            y={0}
            textAnchor="middle"
            dominantBaseline="central"
            style={{
              fontSize: "11px",
              fontWeight: 700,
              fill: "#3B82F6",
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            {order}
          </text>
        </g>
      )}
    </>
  );
};

export default SequenceEdge;
